@if (vm$ | async; as vm) {
  <div class="appointment">
    <div class="appointment-header">
      <w-search (search)="onSearch($event)" />
      @if (canAdd) {
        <w-button (onClick)="openEditor()" iconLeft="fa-regular fa-plus" label="" displayStyle="Secondary" />
      }
    </div>
    <div class="appointment-content">
      <appointment-list-sidebar [appointments]="$safeNavigationMigration(vm?.filteredAppointments)" [timezone]="$safeNavigationMigration(vm?.context?.timezone)" [timeFormat]="$safeNavigationMigration(vm?.context?.settings?.region?.timeFormat)" [readonly]="vm?.context?.readonly === true" (edit)="openEditor($event)" (delete)="onDelete($event)"></appointment-list-sidebar>
    </div>
  </div>
}
